import React from 'react';
import styled from 'styled-components';
import { AdTargetPlace } from '@/api/bff_types';
import useAdBannerHandleViewModel from '@/components/Advertisement/useAdBannerHandleViewModel';

const RightSideBanner = () => {
  const { bannerData, handleAdOutlinkClick } = useAdBannerHandleViewModel(
    AdTargetPlace.PHARMACIST_WEB_SIDE_BIG
  );
  return (
    <BannerWrapper
      imageUrl={bannerData?.bannerImageUrl}
      onClick={handleAdOutlinkClick}
    />
  );
};

export default RightSideBanner;

const BannerWrapper = styled.div<{ imageUrl?: string }>`
  background: ${({ imageUrl }) =>
    imageUrl ? `url(${imageUrl}) center` : 'transparent'};
  display: ${({ imageUrl }) => (imageUrl ? 'block' : 'none')};
  background-size: cover;
  width: 160px;
  height: 480px;
  border-radius: 16px;
  position: absolute;
  top: 114px;
  right: -192px;
  cursor: pointer;
`;
